import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { Box, TextButton, WixIcons } from '../../../../components/common';
import { MainSource } from '../../../../constants/Source';
import { RouteBuilder } from '../../../../utils/RouteHelpers';
import { NewSearchButtonNames, useTrackSearch } from '../../../../utils/hooks/bi/useTrachSearch';
import { useTrackSearchAndFiltersAnalytics } from '../../../../utils/hooks/bi/useTrackSearchAndFiltersAnalytics';
import {
  ClickOrigins,
  ClickOriginsSearchAndFiltersClear,
  SearchAndFiltersShowAllTargets,
} from '../../../../utils/hooks/bi/useTrackSearchAndFiltersAnalytics/useTrackSearchAndFiltersAnalytics.types';
import { IOuter } from '../EmptyState.types';

export const SearchButtons: FC<IOuter> = ({ searchQuery }) => {
  const { trackSearchAndFiltersShowAllClick, trackSearchAndFiltersClear } = useTrackSearchAndFiltersAnalytics();
  const { trackNewSearchClick } = useTrackSearch();

  const history = useHistory();

  const handleAllResultsClick = useCallback(async () => {
    history.push(RouteBuilder.Search(MainSource.All, searchQuery));

    await trackSearchAndFiltersShowAllClick({
      target: SearchAndFiltersShowAllTargets.AllResults,
      clickOrigin: ClickOrigins.Search,
    });

    trackSearchAndFiltersClear(ClickOriginsSearchAndFiltersClear.AllResults);
  }, [history, searchQuery, trackSearchAndFiltersShowAllClick, trackSearchAndFiltersClear]);

  const handleNewSearchClick = useCallback(() => {
    history.push(RouteBuilder.Source(MainSource.MediaFromWix));

    trackNewSearchClick({
      button_name: NewSearchButtonNames.NewSearch,
    });
    trackSearchAndFiltersClear(ClickOriginsSearchAndFiltersClear.Search);
  }, [history, trackNewSearchClick, trackSearchAndFiltersClear]);

  return (
    <Box direction="horizontal" gap={7}>
      <TextButton
        prefixIcon={<WixIcons.SiteSearch />}
        as="a"
        size="small"
        onClick={handleAllResultsClick}
        dataHook="all-results"
      >
        <FormattedMessage id="empty-state.search-all-media-cta" />
      </TextButton>

      <TextButton
        prefixIcon={<WixIcons.Search />}
        as="a"
        size="small"
        onClick={handleNewSearchClick}
        dataHook="new-search"
      >
        <FormattedMessage id="empty-state.search-new-search-cta" />
      </TextButton>
    </Box>
  );
};
